import React from 'react';
import { connect } from 'react-redux';
import Classnames from 'classnames';
import { Link } from 'react-router';
import { hasPermission, toggleCanvassing, updateClientsTableOpenState } from 'actions';
import * as Permissions from 'permissions';
import { ClientsListView } from 'components';

// ********************* HELPER FUNCTION *********************** //
const isMapRoute = route => /^clients\/map/.test(route);
// ************************************************************* //

class ClientsContainerFooter extends React.Component {
  constructor(props) {
    super(props);

    this.handleClickToggleTab = this.handleClickToggleTab.bind(this);
    this.handleClickToggleFiltersFullSize = this.handleClickToggleFiltersFullSize.bind(this);
  }

  handleClickToggleTab() {
    const { clients_table_open_state } = this.props.clients;
    if(clients_table_open_state == 'closed') {
      this.props.updateClientsTableOpenState('half_open');
    }
    else {
      this.props.updateClientsTableOpenState('closed');
    }
  }
  handleClickToggleFiltersFullSize() {
    const { clients_table_open_state } = this.props.clients;
    if(clients_table_open_state == 'open') {
      this.props.updateClientsTableOpenState('half_open');
    }
    else {
      this.props.updateClientsTableOpenState('open');
    }
  }
  componentWillUpdate(next_props) {
    const curr_open = this.props.clients.clients_table_open_state;
    const next_open = next_props.clients.clients_table_open_state;
    const curr_path = this.props.routing.locationBeforeTransitions.pathname;
    const next_path = next_props.routing.locationBeforeTransitions.pathname;
    if(isMapRoute(curr_path) && !isMapRoute(next_path) && curr_open != 'closed') {
      this.props.updateClientsTableOpenState('closed');
      $('.clients-map-view-footer-container').removeClass('half-open open');
      $('.clients-container-footer').removeClass('half-open open');
    }
    if(curr_open != next_open) {
      if(curr_open == 'closed') {
        if(next_open == 'half_open') {
          $('.clients-map-view-footer-container').addClass('half-open');
          $('.clients-container-footer').addClass('half-open');
        }
      }
      else if(curr_open == 'half_open') {
        if(next_open == 'closed') {
          $('.clients-map-view-footer-container').removeClass('half-open open');
          $('.clients-container-footer').removeClass('half-open open');
          $('.toggle-full-size-button').removeClass('inverted');
        }
        else {
          $('.clients-map-view-footer-container').addClass('open');
          $('.clients-map-view-footer-container').removeClass('half-open');
          $('.clients-container-footer').addClass('open');
          $('.clients-container-footer').removeClass('half-open');
          $('.toggle-full-size-button').addClass('inverted');
        }
      }
      else {
        if(next_open == 'half_open') {
          $('.clients-map-view-footer-container').removeClass('open');
          $('.clients-map-view-footer-container').addClass('half-open');
          $('.clients-container-footer').removeClass('open');
          $('.clients-container-footer').addClass('half-open');
          $('.toggle-full-size-button').removeClass('inverted');
        }
        else {
          $('.clients-map-view-footer-container').removeClass('half-open open');
          $('.clients-container-footer').removeClass('half-open open');
          $('.toggle-full-size-button').removeClass('inverted');
        }
      }
    }
  }
  render() {
    const { pathname } = this.props.routing.locationBeforeTransitions;
    const { clients_table_open_state } = this.props.clients;

    const canvassingClass = Classnames({
      btn: true,
      'btn-default': pathname != 'clients/canvassing',
      'btn-primary': pathname == 'clients/canvassing'
    });

    const listClass = Classnames({
      btn: true,
      'btn-default': pathname != 'clients',
      'btn-primary': pathname == 'clients'
    });

    const mapClass = Classnames({
      btn: true,
      'btn-default': !isMapRoute(pathname),
      'btn-primary': isMapRoute(pathname)
    });

    return (
      !this.props.hasPermission('/Account Management/Clients/') && !this.props.hasPermission('/Canvassing/Markers/View/') ? null : (
        <div className='clients-map-view-footer-container'>
          {isMapRoute(pathname) ? (
            <div
              className='toggle-tab'
              onClick={this.handleClickToggleTab}
              >
              <p>{clients_table_open_state == 'closed' ? 'Show Client Filters' : 'Hide Client Filters'}</p>
            </div>
          ) : null}
          {isMapRoute(pathname) ? (
            <div
              className='toggle-full-size-button'
              onClick={this.handleClickToggleFiltersFullSize}
              >
              <i className='fa fa-chevron-up' />
            </div>
          ) : null}
          <div className='clients-map-view-fiters-table-container'>
            <ClientsListView
              page_size_options={['5']}
              handlePageSizeChange={null}
              page_size={5}
            />
          </div>
          <div
            className='clients-container-footer view-switcher clearfix hidden-print'
            ref={this.props.footerRef}
            >
            <div className='col-xs-12 col-md-6 col-md-offset-3 col-lg-4 col-lg-offset-4'>
              <div className='btn-group btn-group-justified'>
                {this.props.hasPermission('/Account Management/Clients/') ? (
                  <Link to='/clients' className={listClass}>
                    <i className='fa fa-list' /> List
                  </Link>
                ) : null}
                <Link
                  to='/clients/map'
                  onClick={e => this.props.toggleCanvassing(false)}
                  className={mapClass}
                  >
                  <i className='fa fa-map' /> Map
                </Link>
                {this.props.hasPermission(Permissions.VIEW_CANVASSING) ?
                  <Link
                    to='/clients/canvassing'
                    onClick={e => this.props.toggleCanvassing(true)}
                    className={canvassingClass}
                    >
                    <i className='fa fa-bullhorn' /> Canvassing
                  </Link> :
                  null}
              </div>
            </div>
          </div>
        </div>
      )
    );
  }
}

const mapStateToProps = ({ clients, routing }) => ({ clients, routing });

export default connect(mapStateToProps, { hasPermission, toggleCanvassing, updateClientsTableOpenState })(ClientsContainerFooter);



// WEBPACK FOOTER //
// ./src/browser/components/clients/clients-container-footer.js